/* REQ-002 卖点区：视频静音切换 */
(function () {
  function init(root) {
    root.querySelectorAll('.selling-points__mute-toggle').forEach((button) => {
      if (button.dataset.muteInit) return;
      button.dataset.muteInit = 'true';
      button.addEventListener('click', () => {
        const video = button.closest('.selling-points__media').querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        button.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
